import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M3.7 16.677V15.29c0-1.532 1.254-2.773 2.8-2.773h7c1.547 0 2.8 1.241 2.8 2.772v1.387M12.475 4.338a3.44 3.44 0 0 1 0 4.9 3.525 3.525 0 0 1-4.95 0 3.44 3.44 0 0 1 0-4.9 3.525 3.525 0 0 1 4.95 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UserIcon20.js.map